import { Box, Stack, Toolbar, Typography } from '@mui/material'
import { LoginSuggestionDialog } from 'components/account/LoginSuggestionDialog'
import { KBottomAppBar } from 'components/core/KBottomAppBar'
import { KButton } from 'components/core/KButton'
import theme from 'core/Theme'
import { TypeRoute } from 'core/TypeRoute'
import { useCurrentStore, useCurrentUser, useOrdering } from 'hooks'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

export const CheckoutFooter = () => {
  const { t } = useTranslation()
  const { tableId } = useParams()
  const { store, formatCurrency } = useCurrentStore()
  const { order, clearSubmitOrderState, canSubmitOrder } = useOrdering()
  const navigate = useNavigate()

  const [showLoginDialog, setShowLoginDialog] = useState(false)
  const { isSignedIn } = useCurrentUser()
  const isContinueAsGuest = useSelector(
    (state: RootState) => state.ordering.isContinueAsGuest,
  )

  const onSubmitOrder = () => {
    if (tableId) {
      navigate(
        generatePath(TypeRoute.TableSubmitOrder, {
          storeId: store.id,
          tableId: tableId,
        }),
      )
    } else {
      navigate(
        generatePath(TypeRoute.SubmitOrder, {
          storeId: store.id,
        }),
      )
    }
  }

  const proceedToCheckout = () => {
    clearSubmitOrderState()
    onSubmitOrder()
  }

  const handleSubmitOrder = () => {
    if (store.is_show_auth && !isSignedIn && !isContinueAsGuest) {
      setShowLoginDialog(true)
    } else {
      proceedToCheckout()
    }
  }

  const handleCloseLoginDialog = () => {
    setShowLoginDialog(false)
  }

  return (
    <>
      <KBottomAppBar>
        <Toolbar disableGutters>
          <Stack sx={{ marginY: 0.5 }}>
            <Typography color="secondary" variant="body2">
              {t('Total')}
            </Typography>
            <Typography variant="h3" color="text.primary">
              {formatCurrency((order?.total ?? 0) - (order?.tip ?? 0))}
            </Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <KButton
            disabled={!canSubmitOrder}
            sx={{
              minWidth: 320,
              height: 52,
              [theme.breakpoints.down('sm')]: {
                minWidth: 240,
                height: 40,
              },
            }}
            onClick={handleSubmitOrder}
          >
            {t('Check Out')}
          </KButton>
        </Toolbar>
      </KBottomAppBar>

      <LoginSuggestionDialog
        open={showLoginDialog}
        onClose={handleCloseLoginDialog}
        onContinueAsGuest={proceedToCheckout}
      />
    </>
  )
}
